/* eslint-disable no-use-before-define,no-mixed-operators */
import React from 'react'
import { hideModal, parseHtml, arrayFrom, fmt } from '../twd'

let freqCodeLabel = (a) => {
    return {
        'A': 'Annually',
        'S': 'Semi-Annually',
        'Q': 'Quarterly',
        'M': 'Monthly'
    }[a] || '-'
}

export default ({issue={}} = {}) => {
    let datum = issue.cachedDatum || {}
    let cpns = arrayFrom(datum.couponSchedule)
    let fcs = arrayFrom(datum.fltfcSchedule)
    let rss = arrayFrom(datum.fltrsSchedule)

    let bms = arrayFrom(datum.fltbmSchedule)
    let f2f = bms
        .map( (a,i,arr) => {
            let r = {
                couponFormula: parseHtml(a.fltrxText),
                reset: a.dt,
                until: arr[i+1] && arr[i+1].dt || issue.maturity
            }
            let rDt = new Date(r.reset)
            let uDt = new Date(r.until)
            let cur = new Date()
            if (cur >= rDt && cur <= uDt) {
                Object.assign(r, {
                    nextDetermination: issue.nextDeterminationDt,
                    nextResetDt: issue.nextResetDate,
                })
            }

            let fc = fcs.filter(a => a.dt === r.reset)[0]
            if (fc) {
                Object.assign(r, {
                    cap: fc.ceiling,
                    floor: fc.floor
                })
            }

            let rs = rss.filter(a => a.dt === r.reset)[0]
            if (rs) {
                r.frequency = freqCodeLabel(rs.freqCode)
            }

            let cpn = cpns.filter(a => a.dt === r.reset)[0]
            if (cpn) {
                Object.assign(r, {
                    couponRate: cpn.coupon,
                    estInd: String(cpn.estInd)==='1',
                })
            }

            return r
        })



    return <React.Fragment>
    <div className="modal-dialog modal-lg">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="bond-detail-ars-info-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center">{issue.f2fFixedInd==='Y'? 'Fixed To Float F2F Info' : 'Floating/Variable FLT Info'}</h3>
            <h5 className="modal-title text-center vertical-offset-sm" dangerouslySetInnerHTML={{__html:parseHtml(issue.formulaText).replaceAll('<BR>', ' ')}}></h5>

            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">

            <div className="table-responsive">
            <table
                data-name='bond-detail-ars-info-table'
                className="table align-top">
            <thead>
                <tr>
                    <th>Reset Frequency</th>
                    <th>Current Reset</th>
                    <th>Next<br/>Reset</th>
                    <th>Next Determination</th>
                    <th>Floor</th>
                    <th>Cap</th>
                    <th width="35%">Formula</th>
                    <th>Coupon Rate</th>
                    <th>Until</th>
                </tr>
            </thead>
            <tbody>
                {f2f.map((a,i) => <tr key={i}>
                    <td>{a.frequency || fmt.empty()}</td>
                    <td>{a.reset}</td>
                    <td>{a.nextResetDt || fmt.empty()}</td>
                    <td>{a.nextDetermination || fmt.empty()}</td>
                    <td>{a.floor || fmt.empty()}</td>
                    <td>{a.cap || fmt.empty()}</td>
                    <td>{a.couponFormula || fmt.empty()}</td>
                    <td>{a.couponRate || fmt.empty()}<sup>{a.estInd ? 'EST': ''}</sup></td>
                    <td>{a.until}</td>
                </tr>)}
            </tbody>
            </table>
            </div>

            </div>
            </div>
        </div>

    </div>
    </div>
    </React.Fragment>
}
